import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ReportMetadata } from '../../models/report.model';
import { ReportdashboardService } from '../../services/reportdashboard.service';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-reportworkflow',
  templateUrl: './reportworkflow.component.html',
  styleUrls: ['./reportworkflow.component.css']
})
export class ReportworkflowComponent implements OnInit {
  reportWorkflowForm: FormGroup;
  approveText: string;
  returnText: string;
  dialogTitle: string;
  reportMetadataId: any;
  dlgMode: string;
  @Output() showHideWorkflowDlg = new EventEmitter<boolean>();
  constructor(
    private fb: FormBuilder,
    private reportDashboardService: ReportdashboardService,
    private notifier: NotifierService
  ) {}

  ngOnInit() {
    this.reportWorkflowForm = this.fb.group({
      status: ['', Validators.required],
      removeAuthor:[false],
      comments: ['']
    });
  }

  ShowWorkflowDialog(id: any, mode: string) {
    this.reportMetadataId = id;
    this.dlgMode = mode;
    this.reportWorkflowForm.reset();

    //TODO: Remove Hard coding
    if (mode == 'Approve') {
      this.approveText = 'Approve and Send to Washington';
      this.returnText = 'Return to Author';
      this.dialogTitle = 'Approve/Return';
    } else {
      // this.approveText = 'Validated and Ready to Publish';
      // this.returnText = 'Return to Author';
      // this.dialogTitle = 'Validate/Return';
      this.returnText = 'Return to Author';
      this.dialogTitle = 'Return to Post Author/Approver';
    }

    this.showHideWorkflowDlg.emit(true);
  }

  SaveWorkflowStatus() {
    //console.log(this.reportWorkflowForm.controls["status"].value);
    //this.reportWorkflowForm.controls[].value

    if (this.reportWorkflowForm.controls['status'].value === 'true') {
      this.reportDashboardService.checkforCommentsandTrackChanges$(this.reportMetadataId).subscribe(data => {
        if (data === false) {
          this.ExecuteWorkflow();
        } else {
          this.notifier.notify(
            'error',
            'Please verify the document for Track changes and comments. Remove track changes and comments to proceed further'
          );
        }
      });
    } else {
      this.ExecuteWorkflow();
    }
  }

  ExecuteWorkflow() {
    // console.log("Remove author" + JSON.stringify(this.reportWorkflowForm.controls['removeAuthor'].value));
    this.reportDashboardService
      .executeWorkflow$(
        this.reportMetadataId,
        this.dlgMode,
        this.reportWorkflowForm.controls['status'].value,
        this.reportWorkflowForm.controls['comments'].value,
        //this.reportWorkflowForm.controls['removeAuthor'].value
        this.reportWorkflowForm.controls['removeAuthor'].value === null ? false : this.reportWorkflowForm.controls['removeAuthor'].value
      )
      .subscribe(
        resp => {

          // Code to load the reportschedules in ReportListing Component
          this.showHideWorkflowDlg.emit(false);

          if (resp.ok) {
            this.notifier.notify(
              'success',
              this.getConfirmationMsg(this.dlgMode, this.reportWorkflowForm.controls['status'].value)
            );
          }
        },
        err => {
          console.log(err);
          this.notifier.notify('error', 'Something went wrong, Please contact Administrator');
        }
      );
    // this.showHideWorkflowDlg.emit(false);
  }
  CloseWorkflowDialog() {
    this.reportWorkflowForm.reset();
    this.showHideWorkflowDlg.emit(false);
  }
  getConfirmationMsg(dlgMode: string, status: string): string {
    if (dlgMode == 'Approve' && status == 'true') {
      return 'Report Approved and Sent to Washington successfully';
    } else if (dlgMode == 'Approve' && status == 'false') {
      return 'Report is returned to Author successfully';
    } else if (dlgMode == 'Validation' && status == 'true') {
      return 'Report is Validated and ready for publication';
    } else if (dlgMode == 'Validation' && status == 'false') {
      return 'Report is returned to Post successfully';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/reportdashboard/reportworkflow/reportworkflow.component.ts